import { compose } from '@beef/utils';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { areNonFunctionFieldsSame } from "../../../../../../../utils/utils";
import { EZIndices } from "../../../../../../../../components/constants";
import { getPortalContainer } from "../../../../../../../../utils/window";
import { withLayoutAnalytics } from "../analytics/withAnalytics";
import { EChild } from "../constants";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ModalLayout = compose(withLayoutAnalytics)( /*#__PURE__*/memo(function (props) {
  var zones = props.zones,
    className = props.className;
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    "aria-modal": "true",
    className: cn('wrapper', cnComponentsTheme()),
    style: {
      zIndex: EZIndices.Default
    },
    "data-t-id": "ModalLayout-ModalLayoutDesktop"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content-wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('header'),
    style: {
      zIndex: EZIndices.Header
    }
  }, zones[EChild.Header]), /*#__PURE__*/React.createElement("div", {
    className: cn('content', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('inputs')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, zones[EChild.Inputs])), /*#__PURE__*/React.createElement("div", {
    className: cn('payments')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('payments-container', 'scroll-container')
  }, zones[EChild.Payments]), /*#__PURE__*/React.createElement("div", {
    className: cn('button-container')
  }, zones[EChild.Button])))))), getPortalContainer());
}, areNonFunctionFieldsSame));